import { useParams } from 'react-router-dom';
import ChatConversation from '../components/chat/ChatConversation';

export default function Chat() {

  const { id } = useParams();

  return (
    <ChatConversation userId={id} />
  );

}